export class templateRenderClassService {

  hostInstance : any;

  constructor(hostIns : any) {
    this.hostInstance = hostIns;
  }

  prepareTemplateBody(elem: any, parsedPayload: any) {
    let temp: any = {};
    temp['type'] = elem.type;
    temp['component'] = {};
    if (!parsedPayload) {
      temp['component'] = {
        "type": elem.type,
        "payload": {
          "type": elem.type,
          "text": elem.value
        }
      };
      temp['cInfo'] = {
        "temp": elem.value
      };
      elem['copyFlag'] = true;

    } else {
      // temp['component'] = parsedPayload.payload ? parsedPayload : parsedPayload.text;
      if (parsedPayload.payload) {
        temp.component = parsedPayload;
      } else if (parsedPayload.text) {
        temp.component = parsedPayload.text;
      } else {
        temp.component = {
          payload: {
            text: parsedPayload
          },
          type: 'text'
        }
      }

      if(temp?.component?.payload?.template_type === 'quick_replies'){
        temp.component.payload.inline = true;
      }

      if (!temp.cInfo) {
        temp.cInfo = {};
      }   
      if (temp?.component && temp?.component?.payload && temp?.component?.payload?.text) {
        temp.cInfo.body = temp.component.payload.text;
      }
      if (temp?.component && temp?.component?.payload && (temp?.component?.payload?.videoUrl || temp?.component?.payload?.audioUrl)) {
        temp.cInfo.body = temp?.component?.payload?.text || '';
      }
    }
    return temp;
  }

  getResponseUsingTemplate(res : any, history = false) {
    let messageId = history ? res._id : res?.id + "-" + (new Date()).getTime()
    let _msgsResponse : any = {
      "type": "bot_response",
      "from": "bot",
      "message": [

      ],
      "messageId": 111 + "-" + (new Date()).getTime(),
      "botInfo": {
        "chatBot": 'st-fa82e7df-fa85-574c-92c7-a6ad6d6da07d',
        "taskBotId": 'st-fa82e7df-fa85-574c-92c7-a6ad6d6da07d'
      },
      "createdOn": "2022-03-21T07:56:18.225Z",
      // "icon": "https://uat.kore.ai:443/api/getMediaStream/market/f-cb381255-9aa1-5ce2-95e3-71233aef7084.png?n=17648985&s=IlRvUlUwalFVaFVMYm9sZStZQnlLc0l1UlZvdlNUUDcxR2o3U2lscHRrL3M9Ig$$",
      "traceId": "873209019a5adc26",
      parsedPayload: null
    }
    res?.buttons?.forEach((elem : any) => {
      let parsedPayload;
      if(elem.value){
        elem.value = elem.value.replace(/(^(&quot\;)|(&quot\;)$)/g, '');
      }
      let payloadType = (elem.value)?.replace(/(&quot\;)/g, "\"");

      try {
        if (payloadType.indexOf('text') !== -1 || payloadType.indexOf('payload') !== -1) {
          let withoutSpecials = payloadType.replace(/^\s+|\s+$/g, "");
          parsedPayload = JSON.parse(withoutSpecials);
        }
      } catch (error) {
        if (payloadType?.text) {
          let withoutSpecials = payloadType.replace(/^\s+|\s+$/g, "");
          parsedPayload = withoutSpecials;
        }
      }

      let body = this.prepareTemplateBody(elem, parsedPayload);

      _msgsResponse.message[0] = body;
      _msgsResponse.parsedPayload = parsedPayload;

    });

    if(res?.formData && res?.formData?.renderType == 'inline' && _msgsResponse?.message && _msgsResponse?.message[0]){
      _msgsResponse.message[0].component = _msgsResponse.message[0].component || {};
      _msgsResponse.message[0].component.formData = res.formData
    }
    return _msgsResponse;
  }

}
